import { render } from "./Ledger.vue?vue&type=template&id=58f9c422&scoped=true&ts=true"
import script from "./Ledger.vue?vue&type=script&lang=ts"
export * from "./Ledger.vue?vue&type=script&lang=ts"

import "./Ledger.vue?vue&type=style&index=0&id=58f9c422&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f9c422"]])

export default __exports__